// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import './debug'
// replacing_debug
import './common/flexible'
import Vue from 'vue'
// 数据上报
import report from './report'
// vuex 仓库
import store from './vuex/store'

// api配置
import rest from './rest'
// 路由配置
import router from './router'

// 样式文件
import './assets/styles/app.less'

// 初始化全局toast
import './common/mixins'

// 初始化 toast
import { registryToast } from './commponents/toast/index'

// 表单校验插件
import ValidatePlugin from './plugins/validate'

// 数据上报所用的一些指令与过滤器
import reportPlugin from './plugins/reportPlugin'

// 入口文件
import App from './App.vue'

Vue.config.productionTip = false

// 注册 toast 组件，无需显式在模板中调用，通过方法调用即可
Vue.use(registryToast)

Vue.use(ValidatePlugin)
Vue.use(reportPlugin)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, // vuex
  rest, // api
  report, // sentry 数据上报
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js